/**
 * Encodes a URI by replacing each instance of certain characters.
 * It became necessary to use this for example for passwords during authorisation processes, when a character such as '\' is used.
 * @param {string} password
 * @returns A new string representing the provided string encoded as a URI.
 */
export const encodePassword = (password: string): string => encodeURI(password);
